import { useSurveyDataStore } from "@/utils/stores/useSurveyDataStore";

export const useHealthAssessment = () => {
    const { surveyData } = useSurveyDataStore();
    const isHealthAssessmentCompleted = () => {
        const healthAssessmentCompleted = surveyData.healthAssessmentCompleted;

        return healthAssessmentCompleted ? healthAssessmentCompleted : false
    };

    return { isHealthAssessmentCompleted }
}